export default "__VITE_ASSET__DeUNXwzU__"